import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadioChecked = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1,
			width: 18,
			height: 18,
			rx: 9,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1,
			width: 18,
			height: 18,
			rx: 9,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 10,
			r: 5,
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgRadioChecked);
export default ForwardRef;
